import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/healthTest2021/Index.vue')

export const healthTest2021Route: RouteConfig = {
  path: '/health-test-2021',
  name: 'healthTest2021Route',
  component: Index,
  meta: {
    title: '邀请有奖',
  },
}

export default [healthTest2021Route]
